import React, { useEffect, useRef, useState } from "react";
import "./About.css";

import logo from "../../Image/scootys image/scooty1//novabike.png";

import {
  FaChargingStation,
  FaMobileAlt,
  FaLeaf,
  FaBatteryFull,
  FaInfoCircle,
} from "react-icons/fa";
import OurTeam from "./OurTeam/OurTeam";

const features = [
  {
    icon: <FaChargingStation />,
    title: "Fast Charging",
    desc: "Quick charging electric scooters that get you back on road in no time.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Easy Online Booking",
    desc: "Book your electric scooter online with a smooth and simple process.",
  },
  {
    icon: <FaLeaf />,
    title: "Eco Friendly Ride",
    desc: "Zero emission scooters designed for a greener and cleaner future.",
  },
  {
    icon: <FaBatteryFull />,
    title: "Long Life Battery",
    desc: "High performance lithium battery with long range and fast recharge.",
  },
  {
    icon: <FaInfoCircle />,
    title: "About Our Scooters",
    desc: "Designed with safety, comfort and smart technology for daily rides.",
  },
];

const About = () => {
  const sectionRef = useRef(null);
  const [show, setShow] = useState(false);

  /* 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA */
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye ho to "smooth"
    });
  }, []);

  /* 🔹 AAPKA EXISTING OBSERVER CODE (UNCHANGED) */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="about-wrapper">
        <div className="about-container">
          <div className="about-content">
            <div className="about-Container_img">
              <img className="about-content_img" src={logo} alt="Logo" />
            </div>

            <div className="about-content_text">
              <h1>
                ABOUT <span>UJALA-E-BIKES</span>
              </h1>

              <div className="divider1">
                <span></span>
                <div className="diamond"></div>
                <span></span>
              </div>

              <p>
                We are a trusted car rental company providing premium vehicles
                with affordable pricing. Our mission is to make your journey
                smooth, safe, and comfortable.
              </p>

              <p>
                With a wide range of vehicles and easy booking, we ensure a
                hassle-free rental experience for everyone.
              </p>

              <button className="about-btn">Explore Our Bike</button>
            </div>
          </div>
        </div>
      </section>

      <section className="sf-section">
        <div className="sf-header">
          <div>
            <span className="sf-tag">Companies Features</span>
            <h2>
              We Make Your Every <br /> Ride Comfortable
            </h2>
          </div>

          <button className="sf-main-btn">Explore more services →</button>
        </div>

        <div className="sf-cards">
          {features.map((item, index) => (
            <div className="sf-card" key={index}>
              <div className="sf-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <button className="sf-read-btn">Read More →</button>
            </div>
          ))}
        </div>
      </section>

      <section className="about-hero">
        <div className="about-hero-overlay" />

        <div className="about-hero-content">
          <div className="about-hero-text">
            <span className="fun-facts">🛵 ECO RIDES</span>
            <h1>
              Save Time & Energy <br />
              with Smart Electric <br />
              Scooty Services
            </h1>
          </div>

          <div className="about-hero-stats">
            <div className="stat-circle">
              <span className="stat-number">1000+</span>
              <span className="stat-text">SATISFY Customers</span>
            </div>
          </div>
        </div>
      </section>

      <OurTeam />
    </>
  );
};

export default About;
